import Vue from "vue";
import { UserAvailability } from "@/lib/utilities/enums";
import CxmApiClient from "@/api/CxmApiClient";
import { NamedRoutes } from "@/lib/utilities/helpers/navigation";
import axios from "axios";

function initialState() {
  return {
    User: {},
    sideNavCollapsed: false,
    showAvailModal: false,
    availabilityReasons: [],
    IsClockingIn: false,
    SingleSelectedStore: null
  };
}

const state = initialState();

const getters = {
  SideNavTemplateEntries(state, getters, rootState, rootGetters) {
    let templateCategories = rootState.Templates.TemplateLookupEnums
      ? rootState.Templates.TemplateLookupEnums.Categories
      : [];

    if (!templateCategories) templateCategories = [];
    else templateCategories = JSON.parse(JSON.stringify(templateCategories));

    if (!templateCategories.some(cat => cat.Name == "All")) {
      templateCategories.splice(0, 0, { Name: "All", Id: -1 });
    }

    const baseRoute = NamedRoutes.Templates.children.Browse;

    return (templateCategories || []).map(cat => ({
      ...baseRoute,
      meta: {
        ...baseRoute.meta,
        sideNavLabel: cat.Name,
        routeObj: {
          ...baseRoute.meta.routeObj,
          query: cat.Id == 0 ? {} : { category: cat.Id }
        }
      }
    }));
  },
  SideNavMenuItems(state, getters, rootState, rootGetters) {
    const user = state.User;
    return Object.values(NamedRoutes)
      .filter(route => route.meta.sideNavGroupLabel)
      .map(route => {
        const builtChildren = [];
        if (route.children) {
          for (const child of Object.values(route.children)) {
            if (
              (typeof child.meta.hasPermission !== "function" ||
                child.meta.hasPermission(user)) &&
              (typeof child.meta.hasFeature !== "function" ||
                child.meta.hasFeature())
            ) {
              let childrenToAdd = [child];
              if (child.meta.sideNavEntriesGetter) {
                childrenToAdd = rootGetters[child.meta.sideNavEntriesGetter];
              }
              if (!Array.isArray(childrenToAdd)) {
                console.warn("Invalid children object");
                console.warn(childrenToAdd);
                continue;
              }

              for (const childToAdd of childrenToAdd) {
                if (childToAdd.meta.sideNavLabel)
                  builtChildren.push(childToAdd);
              }
            } else {
            }
          }
        }

        return {
          ...route,
          children: route.children ? builtChildren : null
        };
      })
      .filter(route => {
        if (!Array.isArray(route.children)) {
          return (
            (typeof route.meta.hasPermission !== "function" ||
              route.meta.hasPermission(user)) &&
            (typeof route.meta.hasFeature !== "function" ||
              route.meta.hasFeature())
          );
        } else return route.children.length > 0;
      });
  },
  User: function(state) {
    return state.User;
  },
  sideNavCollapsed: function(state) {
    return state.sideNavCollapsed;
  },
  showAvailModal(state) {
    return state.showAvailModal;
  },
  availabilityReasons(state) {
    return state.availabilityReasons;
  },
  IsClockingIn(state) {
    return state.IsClockingIn;
  },
  Environment(state) {
    try {
      let env = "production";
      if (process.env.NODE_ENV == "stage") env = "stage";
      else if (process.env.NODE_ENV == "development") {
        if (location.hostname.startsWith("localhost")) env = "localhost";
        else env = "development";
      }
      return env;
    } catch (err) {
      console.log("Error fetching app environment: ", err);
      return "production";
    }
  },
  CxmApiClient(state, getters, rootState, rootGetters) {
    let cxmApiClient = new CxmApiClient(
      state.User,
      rootGetters.AuthorizationHeader
    );
    return cxmApiClient;
  }
};

const actions = {
  getCurrentUser: function(context) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get("/users/currentUser")
        .then(resp => {
          if (!resp.data || !resp.data.Data || !resp.data.Data.UserId)
            reject(resp);
          else {
            context.commit("gotCurrentUser", resp.data.Data);
            resolve(resp.data.Data);
          }
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  toggleSideNav: function(context, val) {
    return new Promise((resolve, reject) => {
      context.commit("toggleSideNav", val);
      resolve();
    });
  },
  toggleAvailModal(context, val) {
    context.commit("toggleAvailModal", val);
  },
  userUpdated: function(context, updatedUser) {
    if (updatedUser.UserId == context.getters.User.UserId) {
      context.commit("userUpdated", updatedUser);
    }
  },
  handleUserFavoriteResponse: function(context, data) {
    context.commit("handleUserFavoriteResponse", data);
  },
  getAvailabilityReasons(context, val) {
    return new Promise((resolve, reject) => {
      if (context.getters.availabilityReasons.length == 0) {
        Vue.http("/users/availabilityreasons")
          .then(function(data) {
            context.commit("getAvailabilityReasons", data.data.Data);
            resolve();
          })
          .catch(function() {});
      }
      resolve();
    });
  },
  putAvailability(context, val) {
    return new Promise((resolve, reject) => {
      var reason = val.Reason;
      var availability = val.Availability;
      if (availability == UserAvailability.Available) {
        context.dispatch("clockin").then(function(data) {
          resolve(data.data.Data);
        });
      } else if (availability == UserAvailability.Busy) {
        Vue.http
          .put("/users/busy/" + reason.time, {
            AvailabilityReasonId: reason.Id,
            Notes: reason.reason
          })
          .then(function(data) {
            resolve(data.data.Data);
          });
      } else if (availability == UserAvailability.NotAvailable) {
        Vue.http.put("/users/clockout").then(function(data) {
          resolve(data.data.Data);
        });
      }
    });
  },
  clockin(context, val) {
    context.commit("updateClockInSpinner", true);
    return new Promise((resolve, reject) => {
      Vue.http
        .put("/users/clockin")
        .then(function(data) {
          context.commit("updateClockInSpinner", false);
          resolve(data);
        })
        .catch(function(data) {
          context.commit("updateClockInSpinner", false);
          reject(data);
        });
    });
  },
  setSingleSelectedStore(context, newStore) {
    context.commit("setSingleSelectedStore", newStore);
  },
  async processBlobRequest(context, request) {
    let url = request.url;

    if (url && !url.startsWith("/")) url = "/" + url;
    url = process.env.MOTOFUZE_API + url;

    let headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: context.getters.AuthorizationHeader
    };

    return await axios({
      method: request.type,
      url: url,
      data: request.payload,
      headers: headers,
      responseType: "blob"
    }).catch(function(error) {
      return error.response;
    });
  }
};

const mutations = {
  gotCurrentUser: function(state, user) {
    // To support global frame
    user.Id = user.UserId;
    user.Name = user.FirstName + " " + user.LastName;
    state.User = user;

    let singleStore = null;
    if (
      Array.isArray(user.ViewSelectedStores) &&
      user.ViewSelectedStores.length > 0
    ) {
      singleStore = user.ViewSelectedStores.find(
        vss => vss.AccountPlatformID == user.AccountPlatformID
      );
      if (!singleStore) singleStore = user.ViewSelectedStores[0];
    }

    state.SingleSelectedStore = singleStore;
  },
  setSingleSelectedStore(state, newStore) {
    state.SingleSelectedStore = newStore;
  },
  toggleSideNav: function(state, sideNavVal) {
    state.sideNavCollapsed = sideNavVal;
  },
  toggleAvailModal(state, val) {
    state.showAvailModal = val;
  },
  userUpdated: function(state, updatedUser) {
    if (state.User.UserId == updatedUser.UserId) {
      let isFavorite = state.User.IsFavorite;
      for (var prop in updatedUser) {
        try {
          state.User[prop] = updatedUser[prop];
        } catch (err) {
          console.log("Error copying property");
        }
      }
      state.User.IsFavorite = isFavorite;
      state.User.Name = state.User.FirstName + " " + state.User.LastName;
    }
  },
  handleUserFavoriteResponse: function(state, updatedUser) {
    if (state.User.Id == updatedUser.Id) {
      state.User.IsFavorite = updatedUser.IsFavorite;
    }
  },
  getAvailabilityReasons(state, val) {
    state.availabilityReasons = val;
  },
  updateClockInSpinner(state, val) {
    state.IsClockingIn = val;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/App.js